import dayjs from 'dayjs'

var localeData = require('dayjs/plugin/localeData')
dayjs.extend(localeData)

export default dayjs